export default __webpack_public_path__ + "static/media/no-meta-backdrop.1df681b9.png";